import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { MapState } from "@evergis/react";

import { redo, reset, setMapView, undo } from "./mapView";
import { getMapView, getMapViewHistoryState } from "./selectors";

export function useMapView(): [MapState, (mapState: MapState) => void] {
  const dispatch = useDispatch();
  const mapView = useSelector(getMapView);

  const updateMapView = useCallback(
    (state: MapState) => {
      dispatch(setMapView(state));
    },
    [dispatch],
  );

  return [mapView, updateMapView];
}

export function useMapViewUndoRedo() {
  const dispatch = useDispatch();

  return {
    undo: useCallback(() => dispatch(undo()), []),
    redo: useCallback(() => dispatch(redo()), []),
    reset: useCallback(() => dispatch(reset()), []),
  };
}

export function useMapViewHistoryState() {
  return useSelector(getMapViewHistoryState);
}
